/* Rarity-tokens gedeeld tussen ProfileItemsAdmin, PlayerProfile en TeamProfile.
   Waarden zijn brand-neutraal en werken in dark+light. Voor niet-bestaande
   rariteit valt het terug op muted-foreground zodat er niks stukloopt. */
export const RARITIES = [
  { r: 'common',    label: 'Common',    color: '#94A3B8' },
  { r: 'rare',      label: 'Rare',      color: '#7BC8FF' },
  { r: 'epic',      label: 'Epic',      color: '#C77BFF' },
  { r: 'legendary', label: 'Legendary', color: '#E4C265' },
]

const _map = Object.fromEntries(RARITIES.map(x => [x.r, x.color]))

/** Kleur voor een rariteit (fallback = neutral grey). */
export function rarityColor(rarity) {
  return _map[rarity] || '#94A3B8'
}

/** Label voor een rariteit (fallback = de raw string). */
export function rarityLabel(rarity) {
  return RARITIES.find(x => x.r === rarity)?.label ?? rarity
}
